import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export function useTabUrl(basePath: string, subKeys: readonly string[]) {
    const location = useLocation();

    // 由當前 URL 算 index
    const getIndexFromPath = () => {
        // 只取最後一段
        const seg = location.pathname.split('/').pop() || '';
        const idx = subKeys.indexOf(seg);
        return idx >= 0 ? idx : 0;
    };

    // lazy init，避免一開始就重算
    const [value, setValue] = useState<number>(getIndexFromPath);

    // 支援瀏覽器前進／後退
    useEffect(() => {
        const onPopState = () => setValue(getIndexFromPath());
        window.addEventListener('popstate', onPopState);
        return () => window.removeEventListener('popstate', onPopState);
    }, []); // 空陣列，確保只掛一次

    // 切 tab 時只更新 state + URL（不觸發真正的路由）
    const handleChange = (_: any, newValue: number) => {
        setValue(newValue);
        const newUrl = `${basePath}/${subKeys[newValue]}`;
        window.history.pushState(null, '', newUrl);
    };

    return { value, handleChange };
}
